import React from 'react'; // Import the stylesheet
import BankManagementFeature from 'features/personal/bankManagement';

const BankManagementPage = () => {
  return <BankManagementFeature />;
};

export default BankManagementPage;
